import React from 'react';
import LensIcon from '@material-ui/icons/Lens';

const TabDataIcon = (props) => (
  <LensIcon fontSize="inherit" viewBox="0 -7 30 30" style={{color: 'green'}} />
);

export default TabDataIcon;



// WEBPACK FOOTER //
// ./src/views/Common/Icons/TabDataStatus.tsx